import MessageIcon from '../styles/img/reports/message.svg';
import WarningIcon from '../styles/img/reports/warning.svg';

export const FEEDBACK_OPTIONS = [
  {
    id: 'suggestion',
    title: 'Faire une suggestion',
    description: 'J\'aimerais proposer une amélioration pour PikkoPay',
    icon: MessageIcon,
    iconColor: '#3B82F6',
    backgroundColor: '#F4F8FF',
  },
  {
    id: 'problem',
    title: 'J\'ai eu un problème',
    description: 'Une fois informée de la situation, l\'équipe réagira au plus vite pour résoudre le problème.',
    icon: WarningIcon,
    iconColor: '#F59E0B',
    backgroundColor: '#FDF2EA',
  }
];

export const SUCCESS_MESSAGES = {
  suggestion: {
    title: "Merci pour la suggestion !",
    message: "Ton idée va être transmise à nos plus gros cerveaux."
  },
  problem: {
    title: "Merci de ton retour",
    message: "L'équipe va faire tout son possible pour résoudre ce problème très vite"
  }
};